// Loading screen: Kielioppi — every §'s tables built at build time (./tables.ts, preloadGrammarTables)
// and every theme's text (its MDX chunk, loadGrammarTheme), so opening a § only renders it. After the
// sections' code. index.ts (the § metas, no engine) is in the app's first chunk already (the lessons'
// and the dictionary's grammar links), so a static import costs nothing.
import { defineWarmup } from '../shell/warmup/step';
import * as grammar from './index';

export const warmup = defineWarmup({
  id: 'grammar',
  order: 400,
  label: 'grammar',
  async run({ progress }) {
    const { grammarThemes } = grammar;
    await grammar.preloadGrammarTables(); // never throws (0 files: the § generates its forms itself)
    progress(0.3);
    let failed: unknown = null;
    for (const [i, t] of grammarThemes.entries()) {
      await grammar.loadGrammarTheme(t.id).catch((e: unknown) => (failed ??= e));
      progress(0.3 + (0.7 * (i + 1)) / grammarThemes.length);
    }
    if (failed) throw failed;
  },
});
